import { RightBannerSlot } from "@/components/ads/positions";
import { EJHEALTH_COLORS, EJHEALTH_TYPE } from "@/lib/theme/ej-health";
import { LrecAd, HalfPageAd } from "../ad-unit";
import { TagCloud } from "../interactive";
import { SidebarListCard } from "./sidebar-list-card";
import type { SidebarItem } from "@/fixtures/ej-health/fixtures";

interface Props {
  popularList: SidebarItem[];
  relatedTags?: string[];
}

/** First two ad units — pairs with the first page of listing items. */
export function SidebarAdRail() {
  return (
    <div className="flex flex-col gap-8 lg:h-full lg:self-stretch">
      <HalfPageAd />
      <RightBannerSlot label="廣告　Ad" />
      <LrecAd sticky />
    </div>
  );
}

/** Popular columns + LREC (+ related tags) — pairs with the infinite-loaded
 *  items that appear below the first page. */
export function SidebarPopularRail({ popularList, relatedTags }: Props) {
  return (
    <div className="flex flex-col gap-8 lg:h-full lg:self-stretch">
      {/* 最新文章 (was 熱門專欄 — QA). Six rows, not five. */}
      <SidebarListCard title="最新文章" items={popularList} />

      {relatedTags && relatedTags.length > 0 && (
        <div className="flex flex-col gap-5">
          <div
            className="flex items-end justify-between pb-3"
            style={{ borderBottom: `1px solid ${EJHEALTH_COLORS.primaryRule}` }}
          >
            <h2
              style={{
                ...EJHEALTH_TYPE.h2,
                color: EJHEALTH_COLORS.dark,
                fontSize: 22,
                lineHeight: "26px",
              }}
            >
              相關主題
            </h2>
          </div>
          <TagCloud tags={relatedTags} />
        </div>
      )}

      {/* The ad sits at the FOOT of the rail, under 相關主題 — QA: "move the
          LREC ad unit under 熱門專欄 to below 相關主題". Being last is also what
          lets it pin without overlapping the editorial blocks below it.

          A different creative from the LREC in the block above: two identical
          ones on a page read as a rendering fault rather than two bookings —
          the same note QA made about the search rail. */}
      <LrecAd sticky src="/images/ej-health/ad-cboe-popular.png" />
    </div>
  );
}

/** Full sidebar = ad rail above the popular rail. Kept for single-column
 *  contexts; the split listing layout uses the two rails directly. */
export function ListingSidebar({ popularList, relatedTags }: Props) {
  return (
    <div className="flex flex-col gap-8">
      <SidebarAdRail />
      <SidebarPopularRail popularList={popularList} relatedTags={relatedTags} />
    </div>
  );
}
